import { createFileRoute } from "@tanstack/react-router";
import { EmailTemplates } from "@/components/EmailTemplates";

function RouteComponent() {
  return <EmailTemplates />;
}

export const Route = createFileRoute("/_authenticated/email-templates/")({
  component: RouteComponent,
  staticData: { page: ["operations", "deals"] },
});
